import React, { Component } from "react";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getMediosVerificacion } from "./../../redux/actions/medios-verificacion-actions";
import {
  Table,
  Container
} from "reactstrap";
import Pagination from "react-js-pagination";

import Loading from "../utils/Loading";
import MedioVerificacion from "./MedioVerificacion";
import { Authorization } from "./../../utils/Authorization";

class ListadoMediosVerificacion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaMediosVerificacionState: [],
      listaMediosVerificacionPageState: [],
      activePage: 1,
      totalPages: 0,
      itemPerPage: 10,
    };
  }

  cargarMediosVerificacion =async ()=>{
   await this.props.getMediosVerificacion();
    this.setState(
      { listaMediosVerificacionState: this.props.mediosVerificacion },
      () => this.validarPaginacion()
    );
  }

  componentDidMount() {
    this.cargarMediosVerificacion();
  }

  filtroMedioVerificacion = (medioVerificacion) => {
    let filtroMedioVerificacion = [];
    if (medioVerificacion.length > 0) {
      filtroMedioVerificacion = this.props.mediosVerificacion.filter((medio) =>
        medio.descripcion
          .toUpperCase()
          .includes(medioVerificacion.toUpperCase())
      );
    } else {
      filtroMedioVerificacion = this.props.mediosVerificacion;
    }

    this.setState(
      { listaMediosVerificacionState: filtroMedioVerificacion },
      () => {
        this.validarPaginacion();
      }
    );
  };

  validarPaginacion = (page = 1, elementos = 10) => {
    let index = elementos * page - elementos;
    let listaMediosVerificacion = [];

    for (let i = 0; i < elementos; i++) {
      listaMediosVerificacion.push(
        this.state.listaMediosVerificacionState[index]
      );

      index++;
    }

    let totalPages = Math.ceil(
      this.state.listaMediosVerificacionState.length / elementos
    );
   // console.log(totalPages);
    this.setState({
      //detallePoaState: listaProductos,
      listaMediosVerificacionPageState: listaMediosVerificacion,
      activePage: page,
      totalPages,
      itemPerPage: elementos,
    });
  };

  render() {
    const { isLoading, mediosVerificacion } = this.props;
    return (
      <div className="pb-6 pt-5 pt-md-7">
        {!isLoading ? (
          <Container fluid>
            <div className="container bg-white border py-3">
              <div className="header-body">
                <div className="row">
                  <div className="form-group  col-md-6 ">
                    <label htmlFor="filtro">
                      Filtro Medios de Verificación
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm text-dark"
                      id="filtro"
                      placeholder="Medio de verificación"
                      onKeyUp={(e) => {
                        e.preventDefault();
                        this.filtroMedioVerificacion(e.currentTarget.value);
                      }}
                    />
                  </div>
                  <div className="col-md-6">
                    <Link
                      className="btn btn-lg btn-info float-right mb-3"
                      to="/admin/medioverificacion/nuevo"
                    >
                      Agregar nuevo Medio Verificación
                    </Link>
                  </div>
                </div>

                <Table
                  style={{ backgroundColor: "#fff", color: "black" }}
                  responsive
                  className="table-striped"
                >
                  <thead>
                    <tr className="text-left">
                      <th>Descripción</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.listaMediosVerificacionPageState.map(
                      (medioVerificacion) =>
                        medioVerificacion !== null &&
                        medioVerificacion !== undefined && (
                          <MedioVerificacion
                            key={medioVerificacion.medioVerificacionId}
                            medioVerificacion={medioVerificacion}
                            user={this.props.user}
                          />
                        )
                    )}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-center">
                  <Pagination
                    prevPageText="ant"
                    nextPageText="sig"
                    firstPageText="prime"
                    lastPageText="ultimo"
                    itemClass="page-item"
                    linkClass="page-link"
                    activePage={this.state.activePage}
                    itemsCountPerPage={this.state.itemPerPage}
                    totalItemsCount={
                      this.state.listaMediosVerificacionState.length
                    }
                    //pageRangeDisplayed={5}
                    onChange={this.validarPaginacion.bind(this)}
                  />
                </div>
              </div>
            </div>
          </Container>
        ) : (
          <Loading></Loading>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    mediosVerificacion: state.mediosVerificacion.mediosVerificacion,
    isLoading: state.mediosVerificacion.isLoading,
    user: state.auth.signed,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMediosVerificacion: () => dispatch(getMediosVerificacion()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  Authorization(ListadoMediosVerificacion, [
    "Responsables de areas",
    "Responsables de productos",
    "Administrador general",
    "Analista del POA",
    "MAE",
  ])
);
